import { render, staticRenderFns } from "./newShareDialog.vue?vue&type=template&id=1f456e01&scoped=true&"
import script from "./newShareDialog.vue?vue&type=script&lang=js&"
export * from "./newShareDialog.vue?vue&type=script&lang=js&"
import style0 from "./newShareDialog.vue?vue&type=style&index=0&id=1f456e01&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f456e01",
  null
  
)

export default component.exports